// Page-level translations - English
export const pagesEn = {
  home: {
    title: 'Home',
    description: 'Discover quality vehicles and personalized service.',
  },
  vehicles: {
    title: 'Vehicles',
    found: 'vehicles found',
    searchPlaceholder: 'Search by brand, model or year...',
    noResults: 'No vehicles found',
    noResultsDescription: 'Try adjusting filters or search criteria',
    orderBy: 'Sort by',
  },
  vehicleDetails: {
    loading: 'Loading vehicle details...',
    notFound: 'Vehicle not found',
    backToVehicles: 'Back to vehicles',
  },
  financing: {
    title: 'Financing',
    subtitle: 'Flexible options tailored to you',
    description:
      'Get the best financing plans with competitive rates and quick approval.',
  },
  consignments: {
    title: 'Consignment',
    subtitle: 'Sell your car with us',
    description:
      'We handle the entire sales process so you get the best value.',
  },
  buyDirect: {
    title: 'Sell Your Car',
    subtitle: 'Fast and secure purchase',
    description:
      'Receive an immediate offer and sell your car with confidence.',
  },
  weSearchForYou: {
    title: 'Car Finder',
    subtitle: 'Tell us what you need',
    description:
      'Describe your ideal vehicle and we will find the best matches.',
  },
};

